@if (activateSwitchApplication && appsFiltered()?.length) {
<div id="page-mask" (click)="closeSwitchApplication()"></div>

<div id="switchApplicationBox">
  <div id="viewContainer">
    <div id="viewGrid">
      <button id="closeButton" class="closeBtn" (click)="closeSwitchApplication()">
        <mat-icon>close</mat-icon>
      </button>
      @for (app of appsFiltered(); track app) {
      <div matTooltipClass="tooltipStyle" [matTooltip]="app.description ? app.description : ''" matTooltipTouchGestures="off">
        <div id="view" (click)="switchApplication(app?.url)">
          <img id="viewImage" src='{{app?.logo[selText?.lang]}}'>
          <div id="viewTitle">
            <div id="viewText" class="noselect">{{app?.title[selText.lang]}}</div>
          </div>
        </div>
      </div>
      }
    </div>
    </div>
  </div>
}